<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_isAMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindowSA">
                        <CCard style="height:100%; overflow: hidden auto;">
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["AG"][obj_data.I > 0? "EA": "AA"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right"
                                                 @click="closeAdd">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <CRow>
                                        <CCol col="12">
                                            <h6 class="card-title section-title2"><span>1</span>{{this.getLanguage["AG"]["BD"]}}  </h6>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol md="4" class="form-group" v-if="getUserInfo.AT !== 4">
                                            <label class="col-form-label-sm">{{this.getLanguage["AG"]["GN"]}}<span class="required" /> :</label>
                                            <customtreeselect :multiple="false"
                                                              :options="dd_agentgroup"
                                                              :defaultExpandLevel="Infinity"
                                                              :clearable="false"
                                                              :flat="true"
                                                              :placeholder="getLanguage['AG']['GN']"
                                                              v-model="obj_data.ATAGI"
                                                              @input="AgentGroupChange"
                                                              :disabled="obj_data.I > 0" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('ATAGI','GN') }}</span>
                                        </CCol>
                                        <CCol md="4" class="form-group">
                                            <CInput :label="getLanguage['AG']['PC'] + ' :'"
                                                    :placeholder="getLanguage['AG']['PC']"
                                                    size="sm"
                                                    :readonly="true"
                                                    v-model="obj_data.PC"></CInput>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol md="4" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage["GL"]["SAGT"]}} :</label>
                                            <treeselect :multiple="false"
                                                        :async="true"
                                                        :load-options="loadSubBrandOptions"
                                                        :cacheOptions="false"
                                                        :options="dd_subagentgroup"
                                                        :key="rtSubBrand"
                                                        :defaultOptions="dd_DefaultSubBrandSearch"
                                                        :disable-branch-nodes="true"
                                                        :searchPromptText="this.getLanguage['GL']['DDTS']"
                                                        :placeholder="this.utilGetDDLanguage('GL.SAGT')"
                                                        v-model="obj_data.SAGAGI"
                                                        openDirection="below"
                                                        :disabled="obj_data.I > 0"
                                                        @input="SubAgentGroupChange" />
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="12">
                                            <h6 class="card-title section-title2"><span>2</span>{{this.getLanguage["AG"]["SUR"]}}  </h6>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol md="4" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage["AG"]["R"]}}<span class="required" /> :</label>
                                            <div class="inline radio-container">
                                                <input type="checkbox" v-model="obj_data.ICS" />
                                                <span class="col-form-label-sm">{{getLanguage['AG']['ICR'] }}</span>
                                            </div>
                                            <treeselect :multiple="false"
                                                        :options="dd_role"
                                                        sort-value-by="LEVEL"
                                                        :default-expand-level="1"
                                                        :placeholder="getLanguage['AG']['R']"
                                                        :limit="1"
                                                        v-model="obj_data.RI"
                                                        :disabled="dd_role.length < 1"
                                                        ref="RI" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('RI', 'R') }}</span>
                                        </CCol>
                                        <CCol md="4" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage["AG"]["UU"]}}<span class="required" /> :</label>
                                            <CInput :placeholder="getLanguage['AG']['UU']"
                                                    size="sm"
                                                    :value="obj_data.U"
                                                    @change="v => obj_data.U = v"
                                                    :disabled="obj_data.I > 0"
                                                    ref="U"></CInput>
                                            <span class="ErrMsg">{{ ValidationErrMsg('U', 'UU') }}</span>
                                        </CCol>
                                        <CCol md="4" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage["AG"]["UDN"]}}<span class="required" /> :</label>
                                            <CInput :placeholder="getLanguage['AG']['UDN']"
                                                    size="sm"
                                                    :value="obj_data.DN"
                                                    @change="v => obj_data.DN = v"></CInput>
                                            <span class="ErrMsg">{{ ValidationErrMsg('DN', 'UDN') }}</span>
                                        </CCol>
                                        <CCol md="4" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage["AG"]["UUP"]}}<span class="required" />
                                                <div class="custom-tooltip" style="position: unset;">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="custom-tooltiptext" style="width: 350px; left: unset; margin-left: -10%">{{getLanguage["AG"]["UPF"]}}</span>
                                                </div>:
                                            </label>
                                            <CInput type="password"
                                                    :placeholder="getLanguage['AG']['UUP']"
                                                    size="sm"
                                                    v-model="obj_data.UP"
                                                    @change="v => obj_data.UP = v"></CInput>
                                            <span class="ErrMsg">{{ ValidationErrMsg('UP', 'UUP') }}</span>
                                        </CCol>
                                        <CCol md="4" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage["AG"]["UCUP"]}}<span class="required" /> :</label>
                                            <CInput type="password"
                                                    :placeholder="getLanguage['AG']['UCUP']"
                                                    size="sm"
                                                    v-model="obj_data.CUP"
                                                    @change="v => obj_data.CUP = v"
                                                    ref="CUP"></CInput>
                                            <span class="ErrMsg">{{ ValidationErrMsg('CUP', 'UCUP') }}</span>
                                        </CCol>
                                        <CCol md="4" class="form-group" v-if="obj_data.I > 0">
                                            <CInput :label="getLanguage['AG']['UE'] + ' :'"
                                                    :placeholder="getLanguage['AG']['UE']"
                                                    size="sm"
                                                    :value="obj_data.E"
                                                    @change="v => obj_data.E = v"></CInput>
                                            <span class="ErrMsg">{{ ValidationErrMsg('E', 'UE') }}</span>
                                        </CCol>
                                        <CCol md="4" class="form-group" v-if="obj_data.I > 0">
                                            <CInput :label="getLanguage['AG']['UPN'] + ' :'"
                                                    :placeholder="getLanguage['AG']['UPN']"
                                                    size="sm"
                                                    :value="obj_data.PN"
                                                    @change="v => obj_data.PN = v"></CInput>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="12">
                                            <h6 class="card-title section-title2"><span>3</span>{{this.getLanguage["AG"]["AST"]}}  </h6>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol md="6" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage["AG"]["WL"]}} :</label>
                                            <CRow>
                                                <CCol col="4" class="pr-0">
                                                    <CInput :placeholder="getLanguage['AG']['WL']" size="sm" :value="obj_data.WLIPS" @change="v => obj_data.WLIPS = v"></CInput>
                                                </CCol>
                                                <CCol col="3" class="px-0">
                                                    <CInput style="margin-left: 3px;" :placeholder="getLanguage['AG']['WLIPR']" size="sm" :value="obj_data.WLIPS_R" @change="v => obj_data.WLIPS_R = v"></CInput>
                                                </CCol>
                                                <CCol col="2" class="px-1">
                                                    <CButton color="outline-dark" size="sm" class="btn-small" @click="addWhiteListIP()">
                                                        <span class='plusIcon cil-plus'></span>{{this.getLanguage["BTN"]["AD"]}}
                                                    </CButton>
                                                </CCol>
                                                <CCol col="3" class="px-1">
                                                    <CButton color="outline-dark" size="sm" class="btn-small" @click="addMyIP()">
                                                        <span class='plusIcon cil-plus'></span>{{this.getLanguage["DM"]["MIP"]}}
                                                    </CButton>
                                                </CCol>
                                            </CRow>
                                            <br />
                                            <div class="row-fluid">
                                                <table class="custom-table custom-table-inPopUp afb-blue">
                                                    <thead>
                                                        <tr>
                                                            <th style="width: 30px;">{{this.getLanguage['GL']['ACT']}}</th>
                                                            <th style="width: 30px;">{{this.getLanguage["GL"]["NO"]}}</th>
                                                            <th>{{this.getLanguage['AG']['WL']}}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    <td colspan="100%" v-if="obj_data.WhiteListIP == 0 || !obj_data.WhiteListIP">{{this.getLanguage['GL']['NR']}}</td>
                                                    <tr v-for="(data,index) in obj_data.WhiteListIP">
                                                        <td>
                                                            <span id="actionBtnCol">
                                                                <i class="cil-trash" @click='removeWhiteListIP(index)'></i> <!--here Remove -->
                                                            </span>
                                                        </td>
                                                        <td>{{ index+1 }}</td>
                                                        <td>{{ data.WLIPS }}</td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </CCol>
                                        <CCol md="6">
                                            <CRow>
                                                <CCol md="6" class="form-group" v-if="checkModuleAccess('EIU', 'SYS', constAccessType.view)">
                                                    <label class="col-form-label-sm">
                                                        {{this.getLanguage["AG"]["ABBOU"]}}<span class="required" /> :
                                                    </label>
                                                    <div class="input-group input-group-sm">
                                                        <input type="text" class="form-control" style="max-width: 100px" v-model="obj_data.ALOD" :disabled="!checkModuleAccess('EIU', 'SYS', constAccessType.edit)" ref="ALOD" />
                                                        <span class="col-form-label-sm">&nbsp;{{getLanguage['AG']['DWL'] }}</span>
                                                    </div>
                                                    <span class="ErrMsg">{{ ValidationErrMsg('ALOD', 'DWL') }}</span>
                                                </CCol>
                                                <CCol md="6" class="form-group" v-if="checkModuleAccess('E2FA', 'SYS', constAccessType.edit)">
                                                    <label class="col-form-label-sm" style="display:block">
                                                        {{this.getLanguage["AG"]["E2FA"]}}
                                                        <div class="custom-tooltip" style="position: unset;">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="custom-tooltiptext" style="width: 350px; left: unset; margin-left: -60%">{{getLanguage["HELP"]["E2FA"]}}</span>
                                                        </div> :
                                                    </label>
                                                    <input type="checkbox" v-model="obj_data.E2FA" />
                                                </CCol>
                                            </CRow>
                                            <CRow>
                                                <CCol md="6" class="form-group" v-if="obj_data.I>0 && obj_data.AT>=3">
                                                    <CInput :label="getLanguage['AG']['AK'] + ' :'"
                                                            size="sm"
                                                            :readonly="true"
                                                            v-model="obj_data.AK"></CInput>
                                                </CCol>
                                                <!--<CCol md="6" class="form-group" v-if="checkModuleAccess('E2FA', 'SYS', constAccessType.edit)">
                                                <label class="col-form-label-sm" style="display:block">
                                                    {{this.getLanguage["AG"]["H2FAC"]}}
                                                    <div class="custom-tooltip" style="position: unset;">
                                                        <i class="fa fa-question-circle"></i>
                                                        <span class="custom-tooltiptext" style="width: 350px; left: unset; margin-left: -60%">{{getLanguage["HELP"]["H2FAC"]}}</span>
                                                    </div> :
                                                </label>
                                                <input type="checkbox" v-model="obj_data.H2FAC" />
                                            </CCol>-->
                                            </CRow>
                                        </CCol>
                                    </CRow>
                                </div>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="saveData()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{ getLanguage["BTN"]["SV"] }}
                                    </CButton>
                                </div>
                                <label class="mandatory_Field">{{this.getLanguage['MANDATORY']['FIELDS']}}</label>

                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>
        <div v-if="bool_isMemberBlacklistDetailV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div style="height: 220px; width:50%">
                        <CCard style="height:100%; overflow: hidden auto;">
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage['MEM']['ABL']}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right"
                                                 @click="close3">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>

                                <div class='subHeaderHR'></div>

                                <CRow>
                                    <CCol col="12">
                                        <label class="col-form-label-sm">{{this.getLanguage["MEM"]["RR"]}}* :</label>
                                        <treeselect :multiple="false"
                                                    :options="dd_rejectreason"
                                                    :placeholder="getLanguage['MEM']['RR']"
                                                    v-model="obj_Reject.reason"
                                                    :limit="1"
                                                    :limitText="count => `+${count}`" />
                                    </CCol>
                                </CRow>
                                <CRow v-if="obj_Reject.reason==999">
                                    <CCol col="12">
                                        <CInput class="margint10" :placeholder="getLanguage['MTA']['RR']" size="sm" :value="obj_Reject.reason2" @change="v => obj_Reject.reason2 = v" :disabled="obj_Reject.reason!=999" maxlength="300"></CInput>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol col="12">
                                        <span class="ErrMsg">{{ ValidationBlackListErrMsg('reason2') }}</span>
                                    </CCol>
                                </CRow>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="saveBlacklist()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{this.getLanguage["BTN"]["SV"]}}
                                    </CButton>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>
        <div v-if="bool_isMemberFreezeDetailV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div style="height: 220px; width:50%">
                        <CCard style="height:100%; overflow: hidden auto;">
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage['MEM']['AF']}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right"
                                                 @click="close4">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>

                                <div class='subHeaderHR'></div>

                                <CRow>
                                    <CCol col="12">
                                        <label class="col-form-label-sm">{{this.getLanguage["MEM"]["FRR"]}}* :</label>
                                        <treeselect :multiple="false"
                                                    :options="dd_rejectreasonF"
                                                    :placeholder="getLanguage['MEM']['FRR']"
                                                    v-model="obj_RejectF.reason"
                                                    :limit="1"
                                                    :limitText="count => `+${count}`" />
                                    </CCol>
                                </CRow>
                                <CRow v-if="obj_RejectF.reason==999">
                                    <CCol col="12">
                                        <CInput class="margint10" :placeholder="getLanguage['MTA']['FRR']" size="sm" :value="obj_RejectF.reason2" @change="v => obj_RejectF.reason2 = v" :disabled="obj_RejectF.reason!=999" maxlength="300"></CInput>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol col="12">
                                        <span class="ErrMsg">{{ ValidationFreezeErrMsg('reason2') }}</span>
                                    </CCol>
                                </CRow>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="saveFreeze()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{this.getLanguage["BTN"]["SV"]}}
                                    </CButton>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>
        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{this.getLanguage["SMB"]["AU"]}}</h2>
                        <CButton size="sm" color="outline-info" v-if="checkModuleAccess2(constAccessType.add)" @click="addData()"><span class='plusIcon cil-plus'></span>{{this.getLanguage["BTN"]["AN"]}}</CButton>
                        <div class="position-absolute" style="right: 30px;" v-if="MaintenancehAdmin==true">
                            {{this.getLanguage["DB"]["BOM"]}}? :
                            <label class="switch">
                                <input type="checkbox" true-value="2" false-value="1" v-model="maintenanceBtn" @click="maintenanceStatus(maintenanceBtn)" />
                                <span class="slider round"></span>
                            </label>
                        </div>
                        <div class="custom-tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol' v-if="getUserInfo.AT !== 4">
                                <span class='searchLabel80'>{{this.getLanguage["DM"]["AGI"]}} :</span>
                                <customtreeselect :multiple="false"
                                                  :options="dd_agentgroupfs"
                                                  :defaultExpandLevel="Infinity"
                                                  :placeholder="this.utilGetDDLanguage('DM.AGI')"
                                                  v-model="searchAGI"
                                                  @input="AgentGroupChangefs" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["SAGT"]}} :</span>
                                <treeselect :multiple="false"
                                            :async="true"
                                            :key="rtSubBrand"
                                            :load-options="loadSubBrandOptions"
                                            :cacheOptions="false"
                                            :defaultOptions="dd_DefaultSubBrandSearch"
                                            :options="dd_subagentgroup"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('GL.SAGT')"
                                            v-model="arr_FV['SAGAGI']"
                                            openDirection="below" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["U"]}} :</span>
                                <CInput size="sm" :value="arr_FV['WC']" @change="v => arr_FV['WC'] = v"></CInput>
                            </div>
                            <div class='searchCol' v-if="!isOUTMOB">
                                <span class='searchLabel'>{{this.getLanguage["GL"]["SD"]}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="arr_FV['DR']"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="arr_FV['DR'].startDate != ''">
                                            <CInput size="sm"
                                                    :value="arr_FV['DR'].startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol' v-if="!isOUTMOB">
                                <span class='searchLabel'>{{this.getLanguage["GL"]["ED"]}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="arr_FV['DR']"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="arr_FV['DR'].endDate != ''">
                                            <CInput size="sm"
                                                    :value="arr_FV['DR'].endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["AG"]["PC"]}} :</span>
                                <CInput size="sm" :value="arr_FV['PC']" @change="v => arr_FV['PC'] = v"></CInput>
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" ref="search" @shortkey="newSearch()" class='searchBtn' size="sm" block color="success" @click="newSearch()">
                                <span class='searchIcon cil-search'></span>
                                <span>{{this.getLanguage["BTN"]["SR"]}}</span>
                            </CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>

            <div class='table-wrapper'>
                <header class="table-header">
                    <strong>{{ this.getLanguage["AG"]["AUL"] }}</strong>
                    <div class="pageBtn">
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{ this.getLanguage["AG"]["I"] }}</th>
                                <th v-if="checkModuleAccess2(constAccessType.edit) || checkModuleAccess2(constAccessType.delete) || checkModuleAccess3(constAccessType.delete) || checkModuleAccess4(constAccessType.delete)">{{ this.getLanguage["GL"]["ACT"] }}</th>
                                <th>{{ this.getLanguage["AG"]["GN"] }}<i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["AG"]["UU"] }}<i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["AG"]["UDN"] }}<i @click="setSortTable('DN')" :class="setSortLogo('DN')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["RL"]["RN"] }}<i @click="setSortTable('RN')" :class="setSortLogo('RN')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["AG"]["UE"] }}<i @click="setSortTable('E')" :class="setSortLogo('E')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["AG"]["UPN"] }}<i @click="setSortTable('PN')" :class="setSortLogo('PN')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["AG"]["WL"] }}</th>
                                <th>{{ this.getLanguage["MEM"]["LLTS"] }}<i @click="setSortTable('LLTS')" :class="setSortLogo('LLTS')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["MEM"]["LLIP"] }}<i @click="setSortTable('LLIP')" :class="setSortLogo('LLIP')" class="sortlogo"></i></th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{ this.getLanguage["AG"]["I"] }}</th>
                                <th v-if="checkModuleAccess2(constAccessType.edit) || checkModuleAccess2(constAccessType.delete) || checkModuleAccess3(constAccessType.delete) || checkModuleAccess4(constAccessType.delete)">{{ this.getLanguage["GL"]["ACT"] }}</th>
                                <th>{{ this.getLanguage["AG"]["GN"] }}<i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["AG"]["UU"] }}<i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["AG"]["UDN"] }}<i @click="setSortTable('DN')" :class="setSortLogo('DN')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["RL"]["RN"] }}<i @click="setSortTable('RN')" :class="setSortLogo('RN')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["AG"]["UE"] }}<i @click="setSortTable('E')" :class="setSortLogo('E')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["AG"]["UPN"] }}<i @click="setSortTable('PN')" :class="setSortLogo('PN')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["AG"]["WL"] }}</th>
                                <th>{{ this.getLanguage["MEM"]["LLTS"] }}<i @click="setSortTable('LLTS')" :class="setSortLogo('LLTS')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["MEM"]["LLIP"] }}<i @click="setSortTable('LLIP')" :class="setSortLogo('LLIP')" class="sortlogo"></i></th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arry.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arry" :class="(data.LFC == 5 || data.RS == 1)? 'blacklist-row' : data.RS == 3? 'freeze-row' : ''">
                            <td>{{ CountItem(index+1) }}</td>
                            <td v-if="checkModuleAccess2(constAccessType.edit) || checkModuleAccess2(constAccessType.delete) || checkModuleAccess3(constAccessType.delete) || checkModuleAccess4(constAccessType.delete)">
                                <span id="actionBtnCol" v-if="!isOUTMOB">
                                    <div class="custom-tooltip" v-if="checkModuleAccess2(constAccessType.delete) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0) && getUserInfo.AID!= data.I">
                                        <i class="cil-trash" @click="removeData(data)"></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                    </div>
                                    <div class="custom-tooltip" v-if="checkModuleAccess2(constAccessType.delete) && (isSENS == 1 && data.AAGI == curAGI && data.AGI != curAGI)&& getUserInfo.AID!= data.I">
                                        <i class="cil-trash" @click="removeData(data)"></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                    </div>
                                    <div class="custom-tooltip" v-if="checkModuleAccess2(constAccessType.delete) && (isSENS == 1 && data.AGI != curAGI && data.AAGI != curAGI)&& getUserInfo.AID!= data.I">
                                        <i class="cil-trash"></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                    </div>
                                    <div class="custom-tooltip" v-if="checkModuleAccess2(constAccessType.edit) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                        <i class="cil-color-border" @click="editData(data.I)"></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                    </div>
                                    <div class="custom-tooltip" v-if="checkModuleAccess2(constAccessType.edit) && (isSENS == 1 && data.AAGI == curAGI && data.AGI != curAGI)">
                                        <i class="cil-color-border" @click="editData(data.I)"></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                    </div>
                                    <div class="custom-tooltip" v-if="checkModuleAccess2(constAccessType.edit) && (isSENS == 1 && data.AGI != curAGI && data.AAGI != curAGI)">
                                        <i class="cil-color-border"></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                    </div>
                                    <!--<div class="custom-tooltip" v-if="checkModuleAccess2(constAccessType.edit) && getUserInfo.AT == 0 && data.LFC == 5">
                                <i class="cil-action-undo sortlogo" @click='unsuspendUser(data)'></i>-->
                                    <!--here Remove -->
                                    <!--<span class="custom-tooltiptext">{{getLanguage["BTN"]["USS"]}}</span>
                                </div>-->
                                    <!--block/unblock agent-->
                                    <div class="custom-tooltip" v-if="checkModuleAccess3(constAccessType.delete) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0) && getUserInfo.AID!= data.I && (getUserInfo.AT == 0 || data.AT > 2)">
                                        <i :class="data.RS == 1?'cil-action-undo':'cil-ban'" @click='BlockUser(data, data.RS == 1)'></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"][data.RS == 1?"UDO":"BLK"]}}</span>
                                    </div>
                                    <div class="custom-tooltip" v-else-if="checkModuleAccess3(constAccessType.delete) && (isSENS == 1 && data.AAGI == curAGI && data.AGI != curAGI) && getUserInfo.AID!= data.I && (getUserInfo.AT == 0 || data.AT > 2)">
                                        <i :class="data.RS == 1?'cil-action-undo':'cil-ban'" @click='BlockUser(data, data.RS == 1)'></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"][data.RS == 1?"UDO":"BLK"]}}</span>
                                    </div>
                                    <div class="custom-tooltip" v-else-if="checkModuleAccess3(constAccessType.delete) && (isSENS == 1 && data.AGI != curAGI && data.AAGI != curAGI) && getUserInfo.AID!= data.I && (getUserInfo.AT == 0 || data.AT > 2)">
                                        <i :class="data.RS == 1?'cil-action-undo':'cil-ban'"></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"][data.RS == 1?"UDO":"BLK"]}}</span>
                                    </div>

                                    <!--freeze/unfreeze agent-->
                                    <div class="custom-tooltip" v-if="checkModuleAccess4(constAccessType.delete) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0) && getUserInfo.AID!= data.I && (getUserInfo.AT == 0 || data.AT > 2)">
                                        <i :class="data.RS == 3?'cil-action-undo':'cil-snowflake'" @click='FreezeUser(data, data.RS)'></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"][data.RS == 3?"UFR":"FK"]}}</span>
                                    </div>
                                    <div class="custom-tooltip" v-else-if="checkModuleAccess4(constAccessType.delete) && (isSENS == 1 && data.AAGI == curAGI && data.AGI != curAGI) && getUserInfo.AID!= data.I && (getUserInfo.AT == 0 || data.AT > 2)">
                                        <i :class="data.RS == 3?'cil-action-undo':'cil-snowflake'" @click='FreezeUser(data, data.RS)'></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"][data.RS == 3?"UFR":"FK"]}}</span>
                                    </div>
                                    <div class="custom-tooltip" v-else-if="checkModuleAccess4(constAccessType.delete) && (isSENS == 1 && data.AGI != curAGI && data.AAGI != curAGI) && getUserInfo.AID!= data.I && (getUserInfo.AT == 0 || data.AT > 2)">
                                        <i :class="data.RS == 3?'cil-action-undo':'cil-snowflake'"></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"][data.RS == 3?"UFR":"FK"]}}</span>
                                    </div>

                                </span>
                                <span id="actionBtnCol" v-if="isOUTMOB">
                                    <span>
                                        <CButton size="sm" type="button" class="btn-danger font-weight-bold text-white mr-2" @click="removeData(data)" v-if="checkModuleAccess2(constAccessType.delete) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0) && getUserInfo.AID!= data.I">
                                            {{getLanguage["BTN"]["DLT"]}}
                                        </CButton>
                                        <CButton size="sm" type="button" class="btn-danger font-weight-bold text-white mr-2" @click="removeData(data)" v-if="checkModuleAccess2(constAccessType.delete) && (isSENS == 1 && data.AAGI == curAGI && data.AGI != curAGI)&& getUserInfo.AID!= data.I">
                                            {{getLanguage["BTN"]["DLT"]}}
                                        </CButton>
                                        <CButton size="sm" type="button" class="btn-danger font-weight-bold text-white mr-2" v-if="checkModuleAccess2(constAccessType.delete) && (isSENS == 1 && data.AGI != curAGI && data.AAGI != curAGI)&& getUserInfo.AID!= data.I">
                                            {{getLanguage["BTN"]["DLT"]}}
                                        </CButton>
                                        <CButton size="sm" type="button" class="btn-warning font-weight-bold text-white mr-2" @click="editData(data.I)" v-if="checkModuleAccess2(constAccessType.edit) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                            {{getLanguage["BTN"]["ED"]}}
                                        </CButton>
                                        <CButton size="sm" type="button" class="btn-warning font-weight-bold text-white mr-2" @click="editData(data.I)" v-if="checkModuleAccess2(constAccessType.edit) && (isSENS == 1 && data.AAGI == curAGI && data.AGI != curAGI)">
                                            {{getLanguage["BTN"]["ED"]}}
                                        </CButton>
                                        <!--block/unblock agent-->
                                        <CButton size="sm" type="button" class="btn-danger font-weight-bold text-white mr-2" @click="BlockUser(data, data.RS == 1)" v-if="checkModuleAccess3(constAccessType.delete) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0) && getUserInfo.AID!= data.I && (getUserInfo.AT == 0 || data.AT > 2)">
                                            {{getLanguage["BTN"][data.RS == 1?"UDO":"BLK"]}}
                                        </CButton>
                                        <CButton size="sm" type="button" class="btn-danger font-weight-bold text-white mr-2" @click="BlockUser(data, data.RS == 1)" v-else-if="checkModuleAccess3(constAccessType.delete) && (isSENS == 1 && data.AAGI == curAGI && data.AGI != curAGI) && getUserInfo.AID!= data.I && (getUserInfo.AT == 0 || data.AT > 2)">
                                            {{getLanguage["BTN"][data.RS == 1?"UDO":"BLK"]}}
                                        </CButton>
                                        <CButton size="sm" type="button" class="btn-danger font-weight-bold text-white mr-2" v-else-if="checkModuleAccess3(constAccessType.delete) && (isSENS == 1 && data.AGI != curAGI && data.AAGI != curAGI) && getUserInfo.AID!= data.I && (getUserInfo.AT == 0 || data.AT > 2)">
                                            {{getLanguage["BTN"][data.RS == 1?"UDO":"BLK"]}}
                                        </CButton>
                                        <!--freeze/unfreeze agent-->
                                        <CButton size="sm" type="button" class="btn-danger font-weight-bold text-white mr-2" @click="FreezeUser(data, data.RS == 3)" v-if="checkModuleAccess4(constAccessType.delete) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0) && getUserInfo.AID!= data.I && (getUserInfo.AT == 0 || data.AT > 2)">
                                            {{getLanguage["BTN"][data.RS == 1?"UFR":"FK"]}}
                                        </CButton>
                                        <CButton size="sm" type="button" class="btn-danger font-weight-bold text-white mr-2" @click="FreezeUser(data, data.RS == 3)" v-else-if="checkModuleAccess4(constAccessType.delete) && (isSENS == 1 && data.AAGI == curAGI && data.AGI != curAGI) && getUserInfo.AID!= data.I && (getUserInfo.AT == 0 || data.AT > 2)">
                                            {{getLanguage["BTN"][data.RS == 1?"UFR":"FK"]}}
                                        </CButton>
                                        <CButton size="sm" type="button" class="btn-danger font-weight-bold text-white mr-2" v-else-if="checkModuleAccess4(constAccessType.delete) && (isSENS == 1 && data.AGI != curAGI && data.AAGI != curAGI) && getUserInfo.AID!= data.I && (getUserInfo.AT == 0 || data.AT > 2)">
                                            {{getLanguage["BTN"][data.RS == 1?"UFR":"FK"]}}
                                        </CButton>
                                    </span>
                                </span>
                            </td>
                            <td>
                                {{ data.GN }} ({{ data.PC }})
                                <div class="custom-tooltip" v-if="data.IGGE">
                                    <img src="https://media.afb.gg/BackOfficeSiteIco/ggearn-ico2.png" class="nwithdraw-icon" />
                                    <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">GGEarn</span>
                                </div>
                            </td>
                            <td>{{ data.U }}</td>
                            <td>{{ data.DN }}</td>
                            <td>{{ data.RN }}</td>
                            <td>{{ data.E }}</td>
                            <td>{{ data.PN }}</td>
                            <td>
                                <span class="grid-line" v-for="ipwhitelist in data.WLIPList">
                                    <span class="grid-line">{{ ipwhitelist.WLIPS }}</span>
                                    <br />
                                </span>
                            </td>
                            <td>{{ Convert1stTimetoNever(formatDateTime(data.LLTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss")) }}</td>
                            <td>{{ data.LLIP }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import Treeselect from '@riophae/vue-treeselect';
    import { customtreeselect } from '@/views/CustomControl/index.js';
    import "@riophae/vue-treeselect/dist/vue-treeselect.css";
    import { mapGetters, mapActions } from "vuex";
    import DateRangePicker from 'vue2-daterange-picker';
    import Loading from "vue-loading-overlay";
    import moment from "moment";
    import 'vue-loading-overlay/dist/vue-loading.css';
    import genericHelper from "@/modules/GenericHelper.js";
    import { required, sameAs, requiredIf, minLength, email, numeric, minValue } from "vuelidate/lib/validators";
    import { constAccessType, constStatus, loadingFullScreen, constRejectReasonBL } from '@/modules/Constant.js';
    import Vue from 'vue'
    import $ from 'jquery'
    //Vue.use(require('vue-shortkey'))

    function validatePassword(value) {
        if (this.obj_data.UP != null && this.obj_data.UP != '') {

            var pattern = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@#$%^&+=!])[A-Za-z\d@#$%^&+=!]{6,32}$/;

            return pattern.test(this.obj_data.UP);
        }
        return true;
    }

    export default {
        mixins: [genericHelper],
        components: {
            Treeselect,
            customtreeselect,
            Loading,
            DateRangePicker
        },
        data() {
            return {
                isSuperA: true,
                bool_CV: false, // Check Validation
                bool_showSearchBar: true,
                //sensBtn: true,
                int_RC: 100, //Row Count
                int_Total: 0,
                int_Page: 1,
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                str_tableSortBy: "CTS", //(sort the table col name)
                bool_isSort: true, // Table Ascending Descending
                arr_FV: {
                    "WC": "",
                    "PC": "",
                    "ATAGI": null,
                    "SAGAGI": null,
                    "DR": {
                        startDate: "",
                        endDate: ""
                    },
                }, //Filter Value
                bool_isAMV: false, // Add Modal Visible
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                maintenanceBtn: true,
                MaintenancehAdmin: false,
                arry: [], //data List
                obj_data: {
                    I: 0,
                    RS: 2,
                    U: "",
                    UP: "",
                    CUP: "",
                    DN: "",
                    E: "",
                    PN: "",
                    RI: null,
                    AGI: 0,
                    PC: "",
                    ATAGI: null,
                    SAGAGI: null,
                    WLIPS: "",
                    WhiteListIP: [],
                    // WLIPList: [],
                    WLIPS_R: "",
                    LFC: 0,
                    ICS: true,
                    ALOD: 92,
                    E2FA: null,
                    H2FAC: null,
                    FB: "",
                    FR: ""
                },
                dd_role: [],
                dd_agentgroup: [],
                dd_agentgroupfs: [],
                dd_subagentgroup: [],
                dd_DefaultSubBrand: [],
                dd_DefaultSubBrandSearch: [],
                rtSubBrand: 0,
                rtSubBrandEdit: 0,
                constAccessType: constAccessType,
                dateMTS: {
                    startDate: this.getTodayDate(),
                    endDate: this.getTodayEndDate()
                },
                obj_WLIPS: {
                    WLIPS: null,
                },
                searchAGI: null,
                bool_isMemberBlacklistDetailV: false,
                bool_blacklistCV: false,
                obj_blacklist: {},
                dd_rejectreason: [],
                obj_Reject: {
                    "reason": null,
                    "reason2": ""
                },
                bool_isMemberFreezeDetailV: false,
                bool_freezeCV: false,
                obj_freeze: {},
                dd_rejectreasonF: [],
                obj_RejectF: {
                    "reason": null,
                    "reason2": ""
                },
            };
        },
        validations: {
            obj_data: {
                U: { required },
                RI: { required },
                ATAGI: { required },
                DN: { required },
                E: { email },
                ALOD: { required, numeric, minValueValue: minValue(0) },
                UP: {
                    required: requiredIf(function (vm) {
                        return vm.I == 0;
                    }),
                    minLength: value => !value || minLength(6)(value), validatePassword
                },
                CUP: {
                    required: requiredIf(function (vm) {
                        return vm.I == 0;
                    }),
                    sameAsPassword: sameAs(function (vm) { return vm.I == 0 || (vm.UP != '' && vm.UP != null) ? vm.UP : vm.CUP; })
                }
            },
            obj_Reject: {
                reason2: {
                    required: requiredIf(function (vm) {
                        return !vm.reason || vm.reason == 999;
                    }),
                }
            },
            obj_RejectF: {
                reason2: {
                    required: requiredIf(function (vm) {
                        return !vm.reason || vm.reason == 999;
                    }),
                }
            }
        },
        computed: {
            ...mapGetters("Language", ["getLanguage"]),
            ...mapGetters('UserInfo', ['getUserInfo']),
            ...mapGetters('UserInfo', ['checkModuleAccess']),
        },
        methods: {
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.arr_FV.DR.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.arr_FV.DR.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.arr_FV.DR.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.arr_FV.DR.endDate = "";
                    }
                }
                if (type == "AMSD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.dateMTS.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.dateMTS.startDate = "";
                    }
                }
                if (type == "AMED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.dateMTS.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.dateMTS.endDate = "";
                    }
                }
            },
            closeAdd() {
                this.bool_isAMV = !this.bool_isAMV;
                this.bool_CV = false;
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('AL', 'SYS', type);
            },
            checkModuleAccess3(type) {
                return this.checkModuleAccess('BU', 'SYS', type);
            },
            checkModuleAccess4(type) {
                return this.checkModuleAccess('FU', 'SYS', type);
            },
            ctrPage(newPage,inputValue = 1) {                
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getList();
            },
            newSearch() {
                if (!this.bool_isAMV) {
                    this.$refs.search.focus();
                    this.int_Page = 1;
                    this.int_IC = 1;
                    this.getList();
                }
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            Convert1stTimetoNever(value) {
                if (value == "01 Jan 1900 00:00:00") {
                    value = "Never";
                    return value;
                }
                else {
                    return value;
                }
            },
            setSortTable(SV) {
                //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort; //change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            getList() {
                this.bool_fullLoading = true;
                var that = this;
                var path = this.getListingParamQuery(
                    this.int_Page,
                    this.int_RC,
                    this.str_tableSortBy,
                    this.bool_isSort
                );
                //search
                if (this.arr_FV) {
                    if (path) {
                        path += "&";
                    }
                    path += (
                        "f.WC=" + (this.arr_FV["WC"] == null ? "" : this.arr_FV["WC"]) +
                        "&f.PC=" + (this.arr_FV["PC"] == null ? "" : this.arr_FV["PC"])
                    );

                    if (this.arr_FV["SAGAGI"]) {
                        path += "&f.ATAGI=" + (this.arr_FV["SAGAGI"] == null ? "" : "4-" + this.arr_FV["SAGAGI"])
                    } else if (this.arr_FV["ATAGI"]) {
                        path += "&f.ATAGI=" + (this.arr_FV["ATAGI"] == null ? "" : this.arr_FV["ATAGI"]);
                    }

                    if (this.arr_FV.DR.startDate != "") {
                        var cts_from = this.parseDateToJsonString(this.arr_FV.DR.startDate);
                        path += "&f.CTS_from=" + cts_from;
                    }
                    if (this.arr_FV.DR.endDate != "") {
                        var cts_to = this.parseDateToJsonString(this.arr_FV.DR.endDate);
                        path += "&f.CTS_to=" + cts_to;
                    }
                }

                this.getDataApi(`/api/agt/l?${path}`, function (d, s) {
                    that.bool_fullLoading = false;
                    if (s) {
                        that.setList(d.D);
                        that.resizeTableHead();
                    }
                });
            },
            AgentGroupChangefs(value) {
                if (value != undefined) {
                    //var agi = 0;
                    if (value != "") {
                        //agi = value.split("-")[1];
                        this.arr_FV["ATAGI"] = value;
                        this.arr_FV["SAGAGI"] = null;
                    }
                }
                else {
                    this.arr_FV["ATAGI"] = null;
                    this.arr_FV["SAGAGI"] = null;
                }
            },
            getAgentGroupDropdown() {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {
                            that.dd_agentgroupfs = that.deepClone(d.dropdownlist);
                            if (that.getUserInfo.AT == 3 && that.dd_agentgroupfs && that.dd_agentgroupfs.length > 0) {
                                that.searchAGI = that.dd_agentgroupfs[0].id;
                            }

                            that.dd_agentgroup = that.deepClone(d.dropdownlist);

                            if (that.getUserInfo.ISENS == 1) {
                                that.dd_agentgroup = that.dd_agentgroup.filter(f => f.id == "3-" + that.getUserInfo.AGI);
                            }
                        }
                    });
            },
            getSubAgentGroupDropdown(value, isFirstLoad = false) {
                if ((isFirstLoad && this.getUserInfo.AT > 3) || !isFirstLoad || (isFirstLoad && value > 3)) {
  
                    var that = this;
                    this.getDataApi(`/api/dd/subbrand/0/0/${value}/1/1`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                if (isFirstLoad) {
                                    that.dd_DefaultSubBrandSearch = that.deepClone(d.dropdownlist);
                                    //that.arr_FV['SAGAGI'] = that.dd_DefaultSubBrandSearch[0].id;
                                    that.rtSubBrand = that.rtSubBrand == 0 ? 1 : 0;
                                    if (that.getUserInfo.AT > 3) {
                                        that.getList();
                                    }
                                }
                                else {
                                    that.dd_DefaultSubBrand = that.deepClone(d.dropdownlist);
                                    that.rtSubBrandEdit = that.rtSubBrandEdit == 0 ? 1 : 0;
                                }
                            }
                        });
                }
            },
            AgentGroupChange(value) {
                if (this.obj_data['I'] == 0) {
                    this.obj_data['DI'] = null;
                }
                var that = this;
                var agi = 0;
                this.obj_data['SAGAGI'] = null;
                var ri = that.obj_data.RI;
                //this.obj_data['RI'] = null;

                if (value != "") {
                    agi = value.split("-")[1];
                    that.obj_data.RI = null;
                    that.dd_role = [];
                }
                this.getDataApi(`/api/ag/g/${agi}`, function (d, s) {
                    if (s) {
                        that.obj_data.PC = d.D.PC;
                    }
                });

                this.getDataApi(`/api/dd/rll/${agi}`, function (d, s) {
                    if (s) {
                        that.dd_role = d.dropdownlist;
                        that.obj_data.RI = ri;                     
                    }
                });
                //that.sensBtn = ((that.isSENS == 1 && agi != that.curAGI) ? true : false);
            },
            SubAgentGroupChange(value) {
                if (this.obj_data['I'] == 0) {
                    this.obj_data['DI'] = null;
                }
                //this.obj_data['RI'] = null;
                var that = this;
                var agi = 0;
                if (value != "" && value != undefined) {
                    agi = value;
                    that.obj_data.RI = null;
                    that.dd_role = [];
                } else {                  
                    agi = that.obj_data.ATAGI.split("-")[1];
                    that.obj_data.RI = null;
                    that.dd_role = [];
                }
                this.getDataApi(`/api/ag/g/${agi}`, function (d, s) {
                    if (s) {
                        that.obj_data.PC = d.D.PC;
                    }
                });

                this.getDataApi(`/api/dd/rll/${agi}`, function (d, s) {
                    if (s) {
                        that.dd_role = d.dropdownlist;
                        if (that.dd_role.length == 1) {
                            that.obj_data.RI = that.dd_role[0].id;
                        }
                    }
                });
            },
            loadSubBrandOptions({ action, searchQuery, callback }) {
                var that = this;
                var parentAGI = 0;

                if (this.obj_data.ATAGI && this.bool_isAMV) {
                    var agentList = this.obj_data.ATAGI.split("-");
                    parentAGI = agentList[agentList.length - 1];
                }
                else if (this.arr_FV["ATAGI"] && !this.bool_isAMV) {
                    var agentList = this.arr_FV["ATAGI"].split("-");
                    parentAGI = agentList[agentList.length - 1];
                }
                else if (this.getUserInfo.AT === 4) {
                    parentAGI = 0;
                }
                else {
                    this.dd_subagentgroup = [];
                    callback(this.getLanguage['MEM']['PSAA']);
                }

                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.dd_subagentgroup = [];
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${parentAGI}/0/1`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.dd_subagentgroup = d.dropdownlist;
                                //that.bool_cacheOptionValue = true;
                            }
                            else {
                                that.dd_subagentgroup = [];
                            }
                            callback(null, that.dd_subagentgroup);
                        });
                }
            },
            setList(data) {
                this.int_TP = Math.max(data.TotalPages, 1);                
                this.int_Total = data.TotalItems;
                this.arry = data.Items;
            },
            setData(data) {
                data.UP = '';
                this.obj_data = data;
                if (this.obj_data.AGI != 0) {
                    this.obj_data.ATAGI = this.obj_data.AT + '-' + this.obj_data.AGI;

                    if (this.obj_data.SAGAGI > 0) {
                        this.obj_data.ATAGI = '3-' + this.obj_data.AGI;
                        this.getSubAgentGroupDropdown(this.obj_data.SAGAGI, true)
                        this.SubAgentGroupChange(this.obj_data.SAGAGI)
                    } else {
                        this.AgentGroupChange(this.obj_data.ATAGI);
                    }
                }
                this.obj_data.WLIPS = "";
                this.obj_data.WLIPS_R = "";
                this.bool_isAMV = true;
            },
            getmaintenanceStatus() {
                var that = this;

                this.getDataApi(`/api/agt/BOMS`, function (d, s) {
                    if (s) {
                        that.maintenanceBtn = d[0].RS
                    }
                });
            },
            maintenanceStatus(value) {
                var titleM = "";
                if (value == "2") {
                    titleM = this.getLanguage['AL']['DMM']
                }
                else {
                    titleM = this.getLanguage['AL']['AYWBOM']

                }
                this.$fire({
                    title: titleM,
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        var rs = "";
                        if (value == "1") {
                            rs = "2";
                        }
                        else {
                            rs = "1";
                        }
                        this.bool_fullLoading = true;
                        var that = this;
                        this.getDataApi(`/api/agt/UBOM/${rs}`,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                if (s) {
                                    that.getList();
                                    that.getmaintenanceStatus();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                    else {
                        this.getList();
                        this.getmaintenanceStatus();
                    }
                });
            },
            addData() {
                this.obj_data = {
                    I: 0,
                    RS: 2,
                    U: "",
                    UP: "",
                    CUP: "",
                    DN: "",
                    E: "",
                    PN: "",
                    RI: null,
                    AGI: 0,
                    PC: "",
                    WLIPS: "",
                    WLIPS_R: "",
                    ATAGI: null,
                    SAGAGI: null,
                    WhiteListIP: [],
                    ICS: true,
                    ALOD: 92,
                    E2FA: null,
                    H2FAC: null,
                    FR: "",
                    FB: ""
                };
                //this.addMyIP();
                this.bool_isAMV = true;
                this.bool_CV = false;

                if (this.getUserInfo.AT == 0) {
                    this.isSuperA = false;
                }
                this.obj_data.ATAGI = this.getUserInfo.AT + "-" + this.getUserInfo.AGI;
                this.AgentGroupChange(this.obj_data.ATAGI);

                if (this.getUserInfo.AT === 4) {
                    this.getSubAgentGroupDropdown(this.getUserInfo.AGI, true);
                }
                else {
                    this.dd_DefaultSubBrandSearch = [];
                }

            },
            ValidationErrMsg(value, langKey = "") {
                var validateObj = this.$v.obj_data[value];

                if (this.bool_CV == true) {
                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["AG"][langKey]);
                    }
                    else if (validateObj.sameAsPassword != undefined && !validateObj.sameAsPassword) {
                        return this.getLanguage['ERR']['3001'];
                    }
                    else if ((validateObj.minLength != undefined && !validateObj.minLength) || (validateObj.maxLength != undefined && !validateObj.maxLength)) {
                        if (value == "UP") {
                            return this.getLanguage['AG']['IUPF'];
                        }
                        else {
                            return String.format(this.getLanguage["AG"]['ERR4'], this.getLanguage["AG"][langKey]);
                        }
                    }
                    else if (validateObj.email != undefined && !validateObj.email) {
                        return String.format(this.utilGetErrorLanguage('1005'), this.getLanguage["AG"][langKey]);
                    }
                    else if (validateObj.numeric != undefined && !validateObj.numeric) {
                        return String.format(this.getLanguage["ERR"]['1009'], this.getLanguage["AG"][langKey]);
                    }
                    else if (validateObj.minValueValue != undefined && !validateObj.minValueValue) {
                        return String.format(this.utilGetErrorLanguage('4442'), this.getLanguage["AG"][langKey]);
                    }
                    else if (validateObj.validatePassword != undefined && !validateObj.validatePassword) {
                        return this.getLanguage['AG']['IUPF'];
                    }
                }
            },
            addMyIP() {
                var WLIPS_C = window.baseIP;
                var exist = false;

                this.obj_WLIPS = {
                    WLIPS: WLIPS_C
                }
                for (var i = 0; i < this.obj_data.WhiteListIP.length; i++) {
                    if (this.obj_data.WhiteListIP[i].WLIPS == WLIPS_C) {
                        exist = true;
                        break;
                    }
                }
                if (exist) {
                    this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1002'), this.getLanguage["AG"]["WL"]), 1000);
                }
                else {
                    this.obj_data.WhiteListIP.push(this.obj_WLIPS);
                }
            },
            addWhiteListIP() {
                var exist = false;
                this.obj_data.WLIPS = this.obj_data.WLIPS ? this.obj_data.WLIPS.trim() : "";
                this.obj_data.WLIPS_R = this.obj_data.WLIPS_R ? this.obj_data.WLIPS_R.trim() : "";
                if (this.obj_data.WLIPS.trim() == "") {
                    this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["AG"]["WL"]), 1000);
                }
                else if (!this.validateIP(this.obj_data.WLIPS)) {
                    this.showErrorMessage(null, this.getLanguage["ERR"]["IIPF"], 1000);
                }
                else {
                    var WLIPS_C = this.obj_data.WLIPS.trim();
                    var ip_rang = this.obj_data.WLIPS_R.trim(); // Trim any whitespace

                    // Validate the IP range if it's not empty
                    if (ip_rang !== "" && (isNaN(ip_rang) || parseInt(ip_rang) < 0 || parseInt(ip_rang) > 255)) {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1014'), this.getLanguage["AG"]["WL"]), 1000);
                        return; // Stop execution if the range is invalid
                    }

                    this.obj_WLIPS = {
                        WLIPS: WLIPS_C
                    }

                    for (var i = 0; i < this.obj_data.WhiteListIP.length; i++) {
                        if (this.obj_data.WhiteListIP[i].WLIPS == WLIPS_C) {
                            exist = true;
                            break;
                        }
                    }

                    if (exist) {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1002'), this.getLanguage["AG"]["WL"]), 1000);
                    } else {
                        this.obj_data.WhiteListIP.push(this.obj_WLIPS);
                        this.obj_data.WLIPS = null;
                    }
                }
                //else {
                //    var WLIPS_C = this.obj_data.WLIPS.trim();                    
                //    var ip_rang = this.obj_data.WLIPS_R;                    
                //    var IP_split = WLIPS_C.split('.');
                //    if (!WLIPS_C.match(/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/)) {
                //        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["AG"]["WL"]), 1000);
                //        checkClear = false;
                //    }

                //    if (ip_rang != "" && ip_rang != null && ip_rang !== "undefined") {
                //        if (!ip_rang.match(/^[0-9]*$/)) {
                //            this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1014'), this.getLanguage["AG"]["WL"]), 1000);
                //            checkClear = false;
                //        } else if (parseInt(ip_rang) <= parseInt(IP_split[3]) || parseInt(ip_rang) > 255) {
                //            this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1013'), this.getLanguage["AG"]["WL"]), 1000);
                //            checkClear = false;
                //        }
                //    }

                //    if (checkClear) {

                //        if (ip_rang != "" && ip_rang != null && ip_rang !== "undefined") {
                //            WLIPS_C = WLIPS_C + '-' + ip_rang;
                //        }

                //        this.obj_WLIPS = {
                //            WLIPS: WLIPS_C
                //        }

                //        for (var i = 0; i < this.obj_data.WhiteListIP.length; i++) {

                //            var row_ip_split = this.obj_data.WhiteListIP[i].WLIPS.split('.');
                //            var new_ip_split = WLIPS_C.split('.');

                //            var row_ip = this.concateIP(row_ip_split);
                //            var new_ip = this.concateIP(new_ip_split);

                //            var row_rang_ip = row_ip_split[3].split('-');

                //            // IF EXITING IP
                //            if (this.obj_data.WhiteListIP[i].WLIPS == WLIPS_C) {
                //                if (ip_rang != "" && ip_rang != null && ip_rang !== "undefined") {
                //                    // IF EXITING IP HAVE RANG
                //                    if (parseInt(ip_rang) <= parseInt(row_rang_ip[1])) {
                //                        exist = true;
                //                        break;
                //                    }
                //                } else {
                //                    // IF EXITING IP HAVE RANG
                //                    if (row_rang_ip[1] != "") {
                //                        if (row_ip == new_ip) {
                //                            exist = true;
                //                            break;
                //                        }
                //                    } else {
                //                        exist = true;
                //                        break;
                //                    }
                //                }
                //            } else {
                //                if (ip_rang != "" && ip_rang != null && ip_rang !== "undefined") {
                //                    if (row_rang_ip[1] != "") {
                //                        if (row_ip == new_ip) {
                //                            if (parseInt(row_rang_ip[0]) == parseInt(new_ip_split[3]) && ip_rang <= row_rang_ip[1]) {
                //                                exist = true;
                //                                break;
                //                            }
                //                        }
                //                    }

                //                } else {
                //                    if (row_rang_ip[1] != "") {
                //                        if (row_ip == new_ip) {
                //                            exist = true;
                //                            break;
                //                        }
                //                    }
                //                }
                //            }
                //        }

                //        if (exist) {
                //            this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1002'), this.getLanguage["AG"]["WL"]), 1000);
                //        }
                //        else {
                //            this.obj_data.WhiteListIP.push(this.obj_WLIPS);                            
                //        }

                //    }
                //}
            },
            //Validate IP in IPv4 and IPv6 Format for Whitelist IP in addWhiteListIP()
            validateIP(ip) {
                return this.validateIPv4(ip) || this.validateIPv6(ip);
            },
            validateIPv4(ip) {
                const ipv4Pattern = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
                return ipv4Pattern.test(ip);
            },
            validateIPv6(ip) {
                const ipv6Pattern = /^(?:[a-fA-F0-9]{1,4}:){7}[a-fA-F0-9]{1,4}|(?:[a-fA-F0-9]{1,4}:){1,7}:|(?:[a-fA-F0-9]{1,4}:){1,6}:[a-fA-F0-9]{1,4}|(?:[a-fA-F0-9]{1,4}:){1,5}(?::[a-fA-F0-9]{1,4}){1,2}|(?:[a-fA-F0-9]{1,4}:){1,4}(?::[a-fA-F0-9]{1,4}){1,3}|(?:[a-fA-F0-9]{1,4}:){1,3}(?::[a-fA-F0-9]{1,4}){1,4}|(?:[a-fA-F0-9]{1,4}:){1,2}(?::[a-fA-F0-9]{1,4}){1,5}|[a-fA-F0-9]{1,4}:(?::[a-fA-F0-9]{1,4}){1,6}|:(?::[a-fA-F0-9]{1,4}){1,7}|::$/i;
                return ipv6Pattern.test(ip);
            },
            concateIP(ip) {
                return ip[0] + '.' + ip[1] + '.' + ip[2] + '.' + ip[3];                
            },
            removeWhiteListIP(index) {
                this.$delete(this.obj_data.WhiteListIP, index);
                this.$forceUpdate();
            },       
            saveData() {
                var disPlayName = this.obj_data.DN;
                this.obj_data.DN = disPlayName.trimLeft();
                var userName = this.obj_data.U;
                this.obj_data.U = userName.trimLeft();
                this.bool_CV = true;

                ////when save, if got subagentid assign it into agentid
                //if (this.obj_data.SAGAGI) {
                //    this.obj_data.ATAGI = "4-" + this.obj_data.SAGAGI;
                //}

                this.$v.obj_data.$touch();
                if (!this.$v.obj_data.$error) {
                    this.bool_fullLoading = true;
                    this.bool_fullScreen = true;
                    var that = this;
                    this.postDataApi(`/api/agt/s`, this.obj_data, function (d, s) {
                        that.bool_fullLoading = false;
                        that.bool_fullScreen = false;                    
                        if (s) {
                            that.bool_isAMV = false;
                            that.getList();
                        }
                        else {
                            if (d.ERR && d.ERR.length > 0 && d.ERR[0].ERRC == 1005) {
                                that.getDataApi(`/api/dd/rll/${that.obj_data.AGI}`, function (d, s) {
                                    if (s) {
                                        that.dd_role = d.dropdownlist;                                        
                                        that.obj_data.RI = null;
                                    }
                                });
                            }
                        }
                    });
                } else {
                    //get the object for validating.
                    const validation = this.$v["obj_data"];
                    if (!validation) {
                        return;
                    }

                    const input = this.findRequiredInput(validation, this.$refs);
                    if (!input || typeof input.focus !== "function") {
                        return;
                    }

                    input.focus();
                }
            },
            getAgentGroup() {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {
                            var agt = that.deepClone(d.dropdownlist);

                            if (agt.length > 0) {
                                var at = 0;
                                at = agt[0].id.split("-")[0];
                                if (at == 0) {
                                    that.MaintenancehAdmin = true;;
                                }
                            }
                        }
                    });

            },
            removeData(d) {
                this.$fire({
                    title: this.getLanguage["GL"]["DLTM"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            i: d.I,
                            uts: d.UTS
                        };

                        this.postDataApi(`/api/agt/d`, dt, function (d, s) {
                            that.bool_fullLoading = false;

                            if (s) {
                                that.getList();
                                that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                            }
                        });
                    }
                });
            },
            editData(id) {
                this.bool_fullLoading = true;
                var that = this;
                this.getDataApi(`/api/agt/g/${id}`, function (d, s) {
                    that.bool_fullLoading = false;
                    if (s) {
                        that.setData(d.D);
                    }
                });
            },

            clearDateRangeFilter() {
                this.arr_FV.DR = {
                    startDate: "",
                    endDate: ""
                };
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },

            //unsuspendUser(d) {
            //    this.$fire({
            //        title: this.getLanguage["AG"]["CUSS"],
            //        width: '30em',
            //        showCancelButton: true,
            //        confirmButtonText: this.getLanguage["GL"]["YES"],
            //        cancelButtonText: this.getLanguage["CNO"]["NO"],
            //        reverseButtons: true,
            //        customClass: {
            //            title: 'afb-alert-title',
            //            content: 'afb-alert-content',
            //            actions: 'afb-alert-action'
            //        }
            //    }).then((result) => {
            //        if (result.value == true) {
            //            this.bool_fullLoading = true;
            //            var that = this;
            //            var dt = {
            //                i: d.I,
            //                uts: d.UTS,
            //                agi: d.AGI
            //            };

            //            this.postDataApi(`/api/agt/usu`, dt,
            //                function (d, s) {
            //                    that.bool_fullLoading = false;
            //                    if (s) {
            //                        that.getList();
            //                        that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
            //                    }
            //                });
            //        }
            //    });
            //},

            BlockUser(d, isBlock) {
                if (isBlock) {
                    this.$fire({
                        title: this.getLanguage["AG"]["CUBLK"],
                        width: '30em',
                        showCancelButton: true,
                        confirmButtonText: this.getLanguage["GL"]["YES"],
                        cancelButtonText: this.getLanguage["CNO"]["NO"],
                        reverseButtons: true,
                        customClass: {
                            title: 'afb-alert-title',
                            content: 'afb-alert-content',
                            actions: 'afb-alert-action'
                        }
                    }).then((result) => {
                        if (result.value == true) {
                            this.bool_fullLoading = true;
                            var that = this;
                            var dt = {
                                i: d.I,
                                uts: d.UTS,
                                agi: d.AGI,
                                CI: d.CI,
                                U: d.U
                            };

                            this.postDataApi(`/api/agt/ubu`, dt,
                                function (d, s) {
                                    that.bool_fullLoading = false;
                                    if (s) {
                                        that.getList();
                                        that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                    }
                                });
                        }
                    });
                } else {
                    this.bool_blacklistCV = false;
                    this.dd_rejectreason = constRejectReasonBL;
                    this.obj_blacklist = {
                        RM: null,
                        _d: d
                    };
                    this.obj_Reject = {
                        "reason": null,
                        "reason2": ""
                    };
                    this.bool_isMemberBlacklistDetailV = true;
                }
            },

            saveBlacklist() {
                this.bool_blacklistCV = true;

                var rejectreason = this.obj_Reject.reason == 999 ? this.obj_Reject.reason2 : this.obj_Reject.reason;

                if (rejectreason != "" && rejectreason != null) {
                    this.bool_fullLoading = true;
                    this.bool_fullScreen = true;
                    var that = this;
                    var dt = [{
                        I: this.obj_blacklist._d.I,
                        UTS: this.obj_blacklist._d.UTS,
                        BR: rejectreason,
                        AGI: this.obj_blacklist._d.AGI,
                        ICI: 0,
                        CI: this.obj_blacklist._d.CI,
                        U: this.obj_blacklist._d.U,
                        PC: this.obj_blacklist._d.PC,
                        AT: this.obj_blacklist._d.AT
                    }];

                    this.postDataApi(`/api/agt/bu`, dt,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            that.bool_fullScreen = false;
                            if (s) {
                                if (d.ERR && d.ERR.length > 0 && d.ERR[0].ERRC == 99) {
                                    that.$fire({
                                        title: that.getLanguage["MEM"]["CA"],
                                        html: that.getLanguage["MEM"]["CICI"],
                                        width: '30em',
                                        showCancelButton: true,
                                        confirmButtonText: 'Ok',
                                        cancelButtonText: 'Cancel',
                                        reverseButtons: true,
                                        customClass: {
                                            title: 'afb-alert-title',
                                            content: 'afb-alert-content',
                                            actions: 'afb-alert-action'
                                        }
                                    }).then((result) => {
                                        if (result.value == true) {
                                            that.bool_fullLoading = true;
                                            dt[0]['ICI'] = 1;
                                            that.postDataApi(`/api/agt/bu`, dt,
                                                function (d, s) {
                                                    that.bool_fullLoading = false;
                                                    if (s) {
                                                        that.bool_isMemberBlacklistDetailV = false;
                                                        that.getList();
                                                    }
                                                });
                                        }
                                    });
                                }
                                else {
                                    that.bool_isMemberBlacklistDetailV = false;
                                    that.getList();
                                }
                            }
                        });
                }
            },
            renderBlackListReason(blackListReason) {
                const found = constRejectReasonBL.some(el => el.id === blackListReason);

                if (found) {
                    for (var d of constRejectReasonBL) {
                        if (d.id == blackListReason) {
                            blackListReason = d.label;
                        }
                    }
                }

                return blackListReason;
            },
            ValidationBlackListErrMsg(value) {
                if (this.bool_blacklistCV) {
                    var validateObj = this.$v.obj_Reject[value];
                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.getLanguage["ERR"]["1001"], this.getLanguage["MEM"]["RR"]);
                    }
                }
            },
            ValidationFreezeErrMsg(value) {
                if (this.bool_freezeCV) {
                    var validateObj = this.$v.obj_RejectF[value];
                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.getLanguage["ERR"]["1001"], this.getLanguage["MEM"]["FRR"]);
                    }
                }
            },
            close3() {
                this.bool_isMemberBlacklistDetailV = !this.bool_isMemberBlacklistDetailV;
                this.bool_blacklistCV = false;
            },
            close4() {
                this.bool_isMemberFreezeDetailV = !this.bool_isMemberFreezeDetailV;
                this.bool_freezeCV = false;
            },

            FreezeUser(d, isFreeze) {
                if (isFreeze == 3) {
                    this.$fire({
                        title: this.getLanguage["AG"]["CUF"],
                        width: '30em',
                        showCancelButton: true,
                        confirmButtonText: this.getLanguage["GL"]["YES"],
                        cancelButtonText: this.getLanguage["CNO"]["NO"],
                        reverseButtons: true,
                        customClass: {
                            title: 'afb-alert-title',
                            content: 'afb-alert-content',
                            actions: 'afb-alert-action'
                        }
                    }).then((result) => {
                        if (result.value == true) {
                            this.bool_fullLoading = true;
                            var that = this;
                            var dt = {
                                i: d.I,
                                uts: d.UTS,
                                agi: d.AGI,
                                //CI: d.CI,
                                //U: d.U
                            };

                            this.postDataApi(`/api/agt/ufu`, dt,
                                function (d, s) {
                                    that.bool_fullLoading = false;
                                    if (s) {
                                        that.getList();
                                        that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                    }
                                });
                        }
                    });
                } else {
                    this.bool_freezeCV = false;
                    //this.dd_rejectreason = constRejectReasonBL;
                    this.obj_freeze = {
                        RM: null,
                        _d: d
                    };
                    this.obj_RejectF = {
                        "reason": null,
                        "reason2": ""
                    };
                    this.bool_isMemberFreezeDetailV = true;
                }
            },
            saveFreeze() {
                this.bool_freezeCV = true;

                var rejectreason = this.obj_RejectF.reason == 999 ? this.obj_RejectF.reason2 : this.obj_RejectF.reason;

                if (rejectreason != "" && rejectreason != null) {
                    this.bool_fullLoading = true;
                    this.bool_fullScreen = true;
                    var that = this;
                    var dt = [{
                        I: this.obj_freeze._d.I,
                        UTS: this.obj_freeze._d.UTS,
                        FR: rejectreason,
                        AGI: this.obj_freeze._d.AGI,
                        ICI: 0
                    }];

                    this.postDataApi(`/api/agt/fu`, dt,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            that.bool_fullScreen = false;
                            if (s) {
                                if (d.ERR && d.ERR.length > 0 && d.ERR[0].ERRC == 99) {
                                    that.$fire({
                                        title: that.getLanguage["MEM"]["CA"],
                                        html: that.getLanguage["MEM"]["CICI"],
                                        width: '30em',
                                        showCancelButton: true,
                                        confirmButtonText: 'Ok',
                                        cancelButtonText: 'Cancel',
                                        reverseButtons: true,
                                        customClass: {
                                            title: 'afb-alert-title',
                                            content: 'afb-alert-content',
                                            actions: 'afb-alert-action'
                                        }
                                    }).then((result) => {
                                        if (result.value == true) {
                                            that.bool_fullLoading = true;
                                            dt[0]['ICI'] = 1;
                                            that.postDataApi(`/api/agt/fu`, dt,
                                                function (d, s) {
                                                    that.bool_fullLoading = false;
                                                    if (s) {
                                                        that.bool_isMemberFreezeDetailV = false;
                                                        that.getList();
                                                    }
                                                });
                                        }
                                    });
                                }
                                else {
                                    that.bool_isMemberFreezeDetailV = false;
                                    that.getList();
                                }
                            }
                        });
                }
            },
            getRejectReasonF() {
                this.dd_rejectreasonF = [{ id: "1", label: this.getLanguage['MEM']['SIMA'] }, { id: "2", label: this.getLanguage['MEM']['HCD'] },
                { id: "3", label: this.getLanguage['MEM']['SAA'] }, { id: "4", label: this.getLanguage['MEM']['IM'] }, { id: "999", label: this.getLanguage['BETRPT']['OTR'] }];
            },
        },
        watch: {
            bool_isAMV() {
                if (!this.bool_isAMV && this.bool_CV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
            getLanguage() {
                this.getList();
                this.getRejectReasonF();
            },
            bool_isMemberBlacklistDetailV(newValue) {
                if (!newValue) {
                    this.cleanSuccessErrorMessage();
                }
                if (!this.bool_isMemberBlacklistDetailV && this.bool_blacklistCV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
        },
        created() {
            this.$parent.showSubMenu = 'SYS';
            this.$parent.showActiveMenu = 'SYS.AL';
            this.getAgentGroup();
            this.getAgentGroupDropdown();
            this.getSubAgentGroupDropdown(this.getUserInfo.AGI, true);
            this.getmaintenanceStatus();
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;
            this.isOUTMOB = (localStorage.getItem('isOutletMobile') == 'True') ? true : false;
            if (this.getUserInfo.AT < 4) {
                this.getList();
            }
            this.getRejectReasonF();
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/SideMenu/SystemSetting/AgentList.vue